import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SchemaMarkupProps {
  schema: object | object[];
}

/**
 * Component to inject JSON-LD structured data into page head
 * Usage: <SchemaMarkup schema={yourSchemaObject} />
 */
export const SchemaMarkup: React.FC<SchemaMarkupProps> = ({ schema }) => {
  const schemas = Array.isArray(schema) ? schema : [schema];
  
  return (
    <Helmet>
      {schemas.map((s, index) => (
        <script key={index} type="application/ld+json">
          {JSON.stringify(s)}
        </script>
      ))}
    </Helmet>
  );
};

/**
 * Convenience component for Organization schema
 */
export const OrganizationSchema: React.FC = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "@id": "https://roautomarket.ro/#organization",
    "name": "RO Auto Market",
    "url": "https://roautomarket.ro",
    "logo": {
      "@type": "ImageObject",
      "url": "https://roautomarket.ro/og-roautomarket.png",
      "width": 512,
      "height": 512
    },
    "description": "Platformă auto pentru România, UK și Germania unde fiecare dealer este verificat manual în Registrul RISCO și la ANAF înainte de prima listare. Fără aprobare automată.",
    "knowsAbout": ["verificare dealeri auto", "RISCO", "ANAF", "mașini second-hand", "dealeri verificați România"],
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "București",
      "addressCountry": "RO"
    },
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "customer service",
      "url": "https://roautomarket.ro/contact",
      "email": "contact@roautomarket.ro",
      "availableLanguage": ["Romanian", "English", "German"]
    },
    "sameAs": [
      "https://www.facebook.com/share/194VhaWZXC/",
      "https://x.com/ROAutoMarket",
      "https://www.instagram.com/roautomarket",
      "https://www.tiktok.com/@www.roautomarket.ro",
      "https://www.youtube.com/@roautomarket",
          "https://www.google.com/maps/place/RO+Auto+Market/@45.1497655,26.8345422,20.25z/data=!4m6!3m5!1s0x40b15f648e2d8401:0xe7871887cc378651!8m2!3d45.1497989!4d26.8348065!16s%2Fg%2F11yyhskh9j"
    ]
  };

  return <SchemaMarkup schema={schema} />;
};
